import { Color } from "../types/color";

export const button = (color: Color) => ({
  MuiButton: {
    styleOverrides: {
      contained: {
        backgroundColor: color.color4,
        fontWeight: '300',
        borderRadius: 8,
        padding: '5px 15px',
        boxShadow: 'none',
        ':hover': {
          backgroundColor: color.color1,
        },
      },
    },
    variants: [
      {
        props: { variant: 'text_primary' },
        style: {
          color: color.color4,
          backgroundColor: 'transparent',
          padding: '6px',
          fontWeight: 'bold',
          '&:hover': {
            color: `${color.color4}ee`,
            backgroundColor: `transparent`,
          }
        },
      },
      {
        props: { variant: 'text_primary_small' },
        style: {
          color: color.color4,
          backgroundColor: 'transparent',
          padding: '0px',
          fontSise: '14px',
          fontWeight: 'bold',
          lineHeight: 1,
          '&:hover': {
            color: `${color.color4}ee`,
            backgroundColor: `transparent`,
          }
        },
      },
      {
        props: { variant: 'container_transparent' },
        style: {
          color: color.color22,
          backgroundColor: color.color5,
          borderRadius: '8px',
          border: `1px solid ${color.color22}`,
          '&:hover': {
            color: color.color22,
            backgroundColor: `${color.color22}0a`,
            borderRadius: '8px',
            border: `1px solid ${color.color22}`,
          }
        },
      },
      {
        props: { variant: 'container_error' },
        style: {
          color: color.color5,
          backgroundColor: color.color19,
          borderRadius: '8px',
          border: `1px solid ${color.color19}`,
          '&:hover': {
            color: color.color5,
            backgroundColor: `${color.color19}f3`,
            borderRadius: '8px',
            border: `1px solid ${color.color19}`,
          }
        },
      },
      {
        props: { variant: 'container_error_outlined' },
        style: {
          color: color.color12,
          backgroundColor: 'transparent',
          borderRadius: '0px',
          border: `1px solid ${color.color12}`,
          '&:hover': {
            color: color.color5,
            backgroundColor: 'transparent',
            border: `1px solid ${color.color12}`,
          }
        },
      },
      {
        props: { variant: 'primary_c' },
        style: {
          color: color.color5,
          backgroundColor: color.primary,
          borderRadius: '8px',
          border: `1px solid ${color.primary}`,
          '&:hover': {
            color: color.color5,
            backgroundColor: `${color.primary}ee`,
            borderRadius: '8px',
            border: `1px solid ${color.primary}`,
          },
          '& .MuiLoadingButton-loadingIndicator': {
            color: color.color5
          },
          '&.Mui-disabled':{
            backgroundColor: `${color.color13}`,
            color: color.color5,
            border: `1px solid ${color.color13}`,
          }
        },
      },
      {
        props: { variant: 'primary_c_break' },
        style: {
          wordBreak: 'break-all',
          fontSize: '12px',
          color: color.color5,
          backgroundColor: color.primary,
          borderRadius: '8px',
          border: `1px solid ${color.primary}`,
          '&:hover': {
            color: color.color5,
            backgroundColor: `${color.primary}ee`,
            borderRadius: '8px',
            border: `1px solid ${color.primary}`,
          },
          '& .MuiLoadingButton-loadingIndicator': {
            color: color.color5
          },
          '&.Mui-disabled':{
            backgroundColor: `${color.color13}`,
          }
        },
      },
      {
        props: { variant: 'primary_c_nr' },
        style: {
          color: color.color5,
          backgroundColor: color.primary,
          borderRadius: '0px',
          border: `1px solid ${color.primary}`,
          '&:hover': {
            color: color.color5,
            backgroundColor: `${color.primary}ee`,
            border: `1px solid ${color.primary}`,
          },
          '& .MuiLoadingButton-loadingIndicator': {
            color: color.color5
          }
        },
      },
      {
        props: { variant: 'dark_c_nr' },
        style: {
          color: color.color5,
          backgroundColor: color.color22,
          borderRadius: '0px',
          border: `1px solid ${color.color22}`,
          '&:hover': {
            color: color.color5,
            backgroundColor: `${color.color22}ee`,
            border: `1px solid ${color.color22}`,
          },
          '& .MuiLoadingButton-loadingIndicator': {
            color: color.color5
          }
        },
      },
      {
        props: { variant: 'blue_c_nr' },
        style: {
          color: color.color5,
          backgroundColor: color.color1,
          borderRadius: '4px',
          '&:hover': {
            color: color.color5,
            backgroundColor: `${color.color1}ee`,
          },
          '& .MuiLoadingButton-loadingIndicator': {
            color: color.color5
          },
          '&.Mui-disabled':{
            backgroundColor: `${color.color13}`,
            color: color.color5
          }
        },
      },
    ]
  },
})
